export default "__VITE_ASSET__DzBXyGN4__"